import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import { useNavigate } from 'react-router-dom';

const AboutUsPage: React.FC = () => {
  const navigate = useNavigate();
  const handleBookRepair = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header title="About Us" />
      
      <div className="container mx-auto px-4 py-8">
        <div className="bg-white rounded-xl p-6 shadow-sm">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
            <h1 className="text-2xl font-semibold text-gray-900 mb-4 sm:mb-0">
              About minto - Your Trusted Mobile Repair Partner
            </h1>
            <button
              onClick={handleBookRepair}
              className="px-6 py-3 bg-minto-500 text-white rounded-lg hover:bg-minto-600 active:bg-minto-700 transition-colors font-medium flex items-center gap-2 shadow-md hover:shadow-lg"
            >
              <i className="fas fa-tools"></i>
              Book Repair
            </button>
          </div>

          <div className="space-y-6 text-gray-600">
            <div>
              <h2 className="text-xl font-medium text-gray-800 mb-3">Our Story</h2>
              <p className="leading-relaxed">
                Founded with a vision to revolutionize mobile repair services in Kalyan, Dombivli, and Palava City, 
                minto has grown to become the most trusted name in doorstep mobile repair services. Our journey began 
                with a simple mission: to provide convenient, professional, and reliable mobile repair services right 
                at our customers' doorsteps.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-medium text-gray-800 mb-3">Our Mission</h2>
              <p className="leading-relaxed">
                We strive to deliver exceptional mobile repair services with transparency, reliability, and 
                convenience. Our mission is to minimize the disruption in our customers' lives by providing quick, 
                efficient, and professional repair services at their preferred location.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-medium text-gray-800 mb-3">Why Choose minto?</h2>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-medium text-gray-900 mb-2">Expert Technicians</h3>
                    <p className="text-sm">
                      Our technicians are certified professionals with years of experience in mobile repair services.
                    </p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-medium text-gray-900 mb-2">Genuine Parts</h3>
                    <p className="text-sm">
                      We use only authentic spare parts to ensure the longevity and performance of your device.
                    </p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-medium text-gray-900 mb-2">90-Day Warranty</h3>
                    <p className="text-sm">
                      All our repairs come with a 90-day warranty for your peace of mind.
                    </p>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-medium text-gray-900 mb-2">Doorstep Service</h3>
                    <p className="text-sm">
                      We come to you - at home, office, or any location of your choice.
                    </p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-medium text-gray-900 mb-2">Transparent Pricing</h3>
                    <p className="text-sm">
                      No hidden costs - we provide upfront pricing before starting any repair.
                    </p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-medium text-gray-900 mb-2">Quick Service</h3>
                    <p className="text-sm">
                      Most repairs are completed within an hour at your location.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-xl font-medium text-gray-800 mb-3">Our Coverage</h2>
              <p className="leading-relaxed mb-4">
                We provide comprehensive mobile repair services across:
              </p>
              <div className="grid md:grid-cols-3 gap-4 text-sm">
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-medium text-gray-900 mb-2">Kalyan</h3>
                  <ul className="list-disc list-inside text-gray-600 space-y-1">
                    <li>Kalyan East</li>
                    <li>Kalyan West</li>
                    <li>Surrounding Areas</li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-medium text-gray-900 mb-2">Dombivli</h3>
                  <ul className="list-disc list-inside text-gray-600 space-y-1">
                    <li>Dombivli East</li>
                    <li>Dombivli West</li>
                    <li>Nearby Localities</li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-medium text-gray-900 mb-2">Palava City</h3>
                  <ul className="list-disc list-inside text-gray-600 space-y-1">
                    <li>Phase 1</li>
                    <li>Phase 2</li>
                    <li>Adjacent Areas</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-gray-200">
              <h2 className="text-lg font-medium text-gray-800 mb-3">Independent Service Provider</h2>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                minto is an independent third-party mobile repair service provider operated by Prajapati Technologies Pvt. Ltd. 
                We are <strong>not affiliated with, authorized by, or endorsed by</strong> Apple Inc., Samsung Electronics, Xiaomi Corporation, 
                OnePlus Technology, Oppo Electronics, Vivo Communication Technology, or any other device manufacturer. 
                All brand names, trademarks, and logos mentioned on this website are the property of their respective owners 
                and are used solely for identification purposes.
              </p>
              <p className="text-sm text-gray-600 leading-relaxed">
                We provide high-quality repair services using compatible replacement parts with our own warranty. 
                Our technicians are independently trained and certified professionals.
              </p>
            </div>

            <div className="mt-6 pt-6 border-t border-gray-200">
              <div className="text-xs text-gray-500 space-y-1">
                <p>Brand by Prajapati Technologies Pvt. Ltd.</p>
                <p>Registered Office: Shop No 2 Vijeta Apartment, Near Thakurli Railway Station, Thakurli (E) 421201</p>
                <p>CIN: U74999MH2017PTC300063</p>
                <p>GST: 27AAJCP4476F1Z4</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Book Repair Button */}
      <div className="fixed bottom-4 sm:bottom-6 left-1/2 transform -translate-x-1/2 z-50 px-4">
        <button
          onClick={handleBookRepair}
          className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-minto-500 text-white rounded-full hover:bg-minto-600 active:bg-minto-700 transition-all duration-300 font-medium flex items-center justify-center gap-2 sm:gap-3 shadow-lg hover:shadow-xl transform hover:scale-105 text-sm sm:text-lg min-w-0"
        >
          <i className="fas fa-tools text-base sm:text-lg"></i>
          <span className="whitespace-nowrap">Book Repair Now</span>
        </button>
      </div>
    </div>
  );
};

export default AboutUsPage; 